var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignalCellularOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1 19.1499L13.5 10.5999L20.4 3.69994C20.7167 3.38327 21.0794 3.31227 21.4881 3.48694C21.896 3.66227 22.1 3.97494 22.1 4.42494V19.1499ZM4.52505 21.9999C4.07505 21.9999 3.76272 21.7956 3.58805 21.3869C3.41272 20.9789 3.48338 20.6166 3.80005 20.2999L10.7 13.3999L3.20005 5.89994C3.01672 5.71661 2.92505 5.48327 2.92505 5.19994C2.92505 4.91661 3.01672 4.68327 3.20005 4.49994C3.38338 4.31661 3.61672 4.22494 3.90005 4.22494C4.18338 4.22494 4.41672 4.31661 4.60005 4.49994L21.6 21.4999C21.7834 21.6833 21.875 21.9166 21.875 22.1999C21.875 22.4833 21.7834 22.7166 21.6 22.8999C21.4167 23.0833 21.1877 23.1749 20.913 23.1749C20.6377 23.1749 20.4001 23.0833 20.2001 22.8999L19.25 21.9999H4.52505Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalCellularOff);
export default __webpack_public_path__ + "static/media/signal-cellular-off.0d12f3406df75e7582b21693f1095277.svg";
export { ForwardRef as ReactComponent };